export default __webpack_public_path__ + "static/media/spunge_logo_tspnt.2232f2d1.png";